import { StyleSheet } from 'react-native';

import { commonMutedText } from './common';
import { colors } from './theme';

export const textStyles = StyleSheet.create({
	lightText: {
		color: colors.textLight,
	},
	muted: {
		...commonMutedText,
	},
	assignee: {
		fontSize: 14,
		fontWeight: '400',
	},
	highlightText: {
		backgroundColor: colors.yellow,
		padding: 1,
		fontWeight: 'bold',
	},
});
